import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { GamesModule } from '@app/_v2/games/games.module';
import { TemplateModule } from '@app/_v2/template/template.module';
import { FiatService } from '@app/core/account/fiat.service';
import { GuideService } from '@app/_v2/games/services/guide.service';

@NgModule({
  imports: [CommonModule, TranslateModule, CoreModule, SharedModule, TemplateModule, GamesModule],
  declarations: [],
  providers: [FiatService, GuideService],
})
export class V2Module {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/v2.module.ts